/**
 * Decision 149: which hostnames are Wave9's OWN portal doors.
 *
 * The sign-in screen adapts to where it's served: on an internal host the
 * full Wave9 front door renders (Microsoft SSO + the admin-key failsafe +
 * Partner sign in); on any OTHER host — viewquote.co.uk today, any future
 * white-label alias automatically — only Partner sign in shows. Partner
 * people and their customers should never meet Wave9 staff sign-in options
 * on the neutral domain.
 *
 * Deliberately a hostname ALLOWLIST of Wave9's own domains, not a check for
 * viewquote specifically — a new alias defaults to the partner-only screen,
 * which is the safe way round.
 */
export function isInternalHost(hostname: string): boolean {
  const h = hostname.toLowerCase()
  return h === 'localhost'
    || h === '127.0.0.1'
    || h === 'wave9.co.uk'
    || h.endsWith('.wave9.co.uk')
    || h.endsWith('.netlify.app')   // the site's own name + deploy previews
}
